import React from 'react';
import './index.less';

export class WatchAnywhere extends React.Component {
	render() {
		return (
			<main className="watch-anywhere">
				<div className="branding">
					<p className="logo">Faithlife TV</p>
				</div>
				<div className="heading">
					<h1>Watch Anywhere</h1>
				</div>
				<div className="subheading">
					Thousands of hours of Bible documentaries, dramas, biographies, kids&#39; videos, and more
				</div>

				<div className="container">
					<div className="block tv">
						<h4>Watch on your TV</h4>
						<p>Enjoy Christian videos right from your couch with our Roku, Apple TV, Fire TV, and Chromecast apps.</p>
						<div className="last">
							<img src="/public/images/watch-anywhere-apps.png" alt="apps" />
						</div>
					</div>
					<div className="block mobile">
						<h4>Watch on a mobile device</h4>
						<p>Take your movies and shows on the go with our mobile apps for iOS and Android.</p>
						<div className="app-icons last">
							<a href="https://apps.apple.com/us/app/faithlife-tv/id1025325721?ls=1">
								<img src="/public/images/apple-app-store-badge.svg" alt="App Store" />
							</a>
							<a href="https://play.google.com/store/apps/details?id=com.faithlife.tvapp.android">
								<img src="/public/images/google-play-badge.svg" alt="Play Store" />
							</a>
						</div>
					</div>
					<div className="block web">
						<h4>Watch on the web</h4>
						<p>
							Stream Faithlife TV Plus videos anytime by visiting faithlifetv.com and logging in with your Faithlife
							account.
						</p>
						<div className="button-container last">
							<a href="/" className="button">
								Browse Faithlife TV
							</a>
						</div>
					</div>
				</div>
			</main>
		);
	}
}
